import { cls } from "../domain/context.js";
import { esc } from "../lib/fmt.js";

export function classChip(classId) {
  const c = cls(classId);
  if (!c) return "";
  return `<span class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
    style="background:${c.color}1A;color:${c.color}">
    <span class="w-1.5 h-1.5 rounded-full" style="background:${c.color}"></span>${esc(c.name)}</span>`;
}

export const ATT = {
  geldi:   { label: "Geldi",   dot: "bg-teal",  chip: "bg-teal-soft text-teal" },
  izinli:  { label: "İzinli",  dot: "bg-sun",   chip: "bg-sun-soft text-[#B07E14]" },
  gelmedi: { label: "Gelmedi", dot: "bg-coral", chip: "bg-coral-soft text-coral" },
};
export const PAY = {
  odendi:   { label: "Ödendi",   chip: "bg-teal-soft text-teal" },
  kismi:    { label: "Kısmi",    chip: "bg-sky-soft text-sky" },
  bekliyor: { label: "Bekliyor", chip: "bg-sun-soft text-[#B07E14]" },
  gecikti:  { label: "Gecikti",  chip: "bg-coral-soft text-coral" },
};
export const EVENT_TYPE = {
  etkinlik: { label: "Etkinlik", color: "#0E9E8F" },
  toplanti: { label: "Toplantı", color: "#4EA8DE" },
  atolye:   { label: "Atölye",   color: "#8E7CC3" },
  gezi:     { label: "Gezi",     color: "#F6B93B" },
  tatil:    { label: "Tatil",    color: "#EE6C5A" },
};

export function card(inner, extra = "") {
  return `<div class="bg-card rounded-2xl shadow-card border border-line/70 ${extra}">${inner}</div>`;
}
export function sectionTitle(txt, right = "") {
  return `<div class="flex items-center justify-between mb-3">
    <h2 class="font-display font-bold text-base">${txt}</h2>${right}</div>`;
}
export function emptyNote(txt) {
  return `<div class="text-sm text-inksoft/80 py-6 text-center">${txt}</div>`;
}
